export const UPPER = 'upper'
export const LOWER = 'lower'

export const ALL_TENSION_PULLEY_LOCATION_TYPES = [
  UPPER,
  LOWER,
] as const

export type TensionPulleyLocationType = typeof ALL_TENSION_PULLEY_LOCATION_TYPES[number]
